module.exports = __webpack_public_path__ + "img/16.a8999bf2.png";